import { Link } from 'react-router';
import type { ClassroomSummary } from '../../shared/api/types';
import { bibleLink } from '../bible/BiblePage';

export const ageRange = (min: number | null, max: number | null) =>
  min !== null && max !== null ? `${min} a ${max} años` : min !== null ? `${min} años o más` : max !== null ? `hasta ${max} años` : null;

export const PARTICIPATION = ['Nada', 'Poca', 'Buena', 'Excelente'] as const;

export const shortDate = (iso: string) => new Date(iso).toLocaleString('es', { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

/** Versículos separados por ";" o saltos de línea, cada uno con enlace a la Biblia. */
export function Verses({ text, invalid = [] }: { text: string; invalid?: string[] }) {
  const refs = text.split(/[;\n]/).map((r) => r.trim()).filter(Boolean);
  return (
    <span className="verses">
      {refs.map((r) =>
        invalid.includes(r) ? (
          <span key={r} className="verse-chip verse-chip--bad" title="No es una cita válida: corrígela en «Editar clase».">
            ⚠ {r}
          </span>
        ) : (
          <Link key={r} to={bibleLink(r)} className="verse-chip">
            {r}
          </Link>
        ),
      )}
    </span>
  );
}

const KID_COLORS = ['#ff8a3d', '#3db2ff', '#7bd46a', '#c77dff', '#ffc53d', '#ff5d8f'];
export const kidColor = (i: number) => KID_COLORS[i % KID_COLORS.length]!;

/** Tarjeta de salón (en Raíces Kids, colorida). */
export function ClassroomCard({ c, index = 0 }: { c: ClassroomSummary; index?: number }) {
  const ages = ageRange(c.minAge, c.maxAge);
  return (
    <li>
      <Link to={`/app/salones/${c.id}`} className={`ministry-card classroom-card${c.ministry.kids ? ' classroom-card--kids' : ''}`} style={c.ministry.kids ? { borderTopColor: kidColor(index) } : undefined}>
        <span className="ministry-card__head">
          <strong>{c.name}</strong>
          {c.role === 'student' ? <span className="badge badge--active">Mi salón</span> : c.role === 'teacher' ? <span className="badge badge--active">Enseño</span> : null}
        </span>
        {ages ? <span className="small classroom-card__ages">{ages}</span> : null}
        <span className="small muted">
          {c.studentCount} {c.studentCount === 1 ? 'alumno' : 'alumnos'}
          {c.teachers.length ? ` · Maestro: ${c.teachers.map((t) => t.name).join(', ')}` : ''}
        </span>
        {c.nextSession ? (
          <span className="small">
            Próxima clase: {shortDate(c.nextSession.startsAt)}
            {c.nextSession.topic ? ` · ${c.nextSession.topic}` : ''}
          </span>
        ) : null}
      </Link>
    </li>
  );
}
